import script from "./SolutionTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SolutionTable.vue?vue&type=script&setup=true&lang=js"

import "./SolutionTable.vue?vue&type=style&index=0&id=3b9a5e4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b9a5e4e"]])

export default __exports__